import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';

const ConfirmationModal = ({
  defer, title, icon, message, okButtonText = 'Yes'
}) => {
  const t = useTranslation();

  return (
    <div className="popup-content popup-small">
      {title && <p className="popup-title">{t(title)}</p>}
      <div className="popup-main-content">
        {icon && <i className={`global-icon popup-main-icon icon-${icon}`} />}
        <p className="text-center">{t(message)}</p>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={() => defer.resolve(false)}
          className="popup-cancel-button"
        >
          {t('Cancel')}
        </button>
        <button
          type="button"
          onClick={() => defer.resolve(true)}
          className="popup-confirm-button"
        >
          {t(okButtonText)}
        </button>
      </div>
    </div>
  );
};

export default ConfirmationModal;

ConfirmationModal.propTypes = {
  defer: PropTypes.bool,
};
